import type { ProductStatus } from '~/schemas/shopify/admin.types';

export enum IPickPageType {
  HOME = 'HOME',
  LANDING = 'LANDING',
  PRODUCT = 'PRODUCT',
  COLLECTION = 'COLLECTION',
  BLOG_POST = 'BLOG_POST',
}

/**
 * One row of the modal, whichever storefront record it was read off. The fields below are the
 * common shape the four Shopify listings are mapped into — see `pickPageItem`.
 */
export interface IPickPageItem {
  id: string;
  /**
   * How a pick is stored on a campaign: a product keeps the platform GID it is listed under, the
   * other three carry the plain numeric id. A row has to keep spelling it the way saved campaigns
   * do, or no stored pick matches it back.
   */
  baseID: string;
  handle?: string;
  title?: string;
  image?: string;
  /** Products only — the other page types carry no status of their own. */
  status?: ProductStatus;
  /** Products only — when the product was published to the Online Store channel. */
  publishedAt?: string;
  templateSuffix?: string;
  url: string;
  type: IPickPageType;
  /**
   * Whether the storefront serves this page right now — what a page, an article and a collection
   * report their availability with. A product has none: it answers with `publishedAt` and `status`
   * instead, so a product row leaves this undefined — see `isPickPageOnlineStoreAvailable`.
   */
  isPublished?: boolean;
}
